import { emptys } from "../../../data/main";

export const updateWindowValue = ({
  key,
  code,
  field,
  value,
  level = 0,
  windowValues,
  setWindowValues,
  windowValues2,
  setWindowValues2,
}: {
  key?: string;
  code: string | number;
  field?: string;
  value: any;
  level?: number;
  windowValues: any;
  setWindowValues: any;
  windowValues2: any;
  setWindowValues2: any;
}) => {
  let tempValue = level === 1 ? { ...windowValues2 } : { ...windowValues };
  if (field && key) {
    tempValue[key][code][field] = value;
  } else if (key) {
    tempValue[key][code] = value;
  } else {
    tempValue[code] = value;
    switch (code) {
      case "TIP":
        if (tempValue.TIP !== 1) {
          tempValue.FOR = 0;
        }
        break;
      case "TRACAJ":
      case "FLOWCAJ":
        if (
          emptys.includes(tempValue.TRACAJ) ||
          ![1].includes(tempValue.FLOWCAJ)
        ) {
          tempValue.RESCAJ = 0;
        }
        break;
    }
  }

  if (level === 1) {
    setWindowValues2({ ...tempValue });
  } else {
    setWindowValues({ ...tempValue });
  }
};
